module.exports = __webpack_public_path__ + "static/img/14010115.8c9c5428.png";